export enum StickerFormatEnum {
  Video = 'VIDEO',
  Audio = 'AUDIO',
  Image = 'PHOTO',
  Upload = 'IMAGE'
}



// WEBPACK FOOTER //
// ./src/app/modules/stickers/domain/enums/StickerFormatEnum.ts